 <wiz-group  width="100%" height="100%">
  coucou

 </wiz-group>
 
